import React, { useState } from 'react';

function Tab({ tabs }) {
  const [activeTab, setActiveTab] = useState(tabs[0].id);

  return (
    <div className=""> {/* Changed max-w-lg to w-80vw */}
      <div className="flex pt-3">
        {tabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`${activeTab === tab.id
              ? 'border-[#ebcab3] text-[#3d0707]'
              : 'border-transparent text-[#ebcab3] hover:text-[#3d0707]'
              } flex-1 inline-flex justify-center py-2 px-6 border-b-2 uppercase`}
          >
            <p className='font-bold'>{tab.label}</p>
          </button>
        ))}
      </div>

      <div className="p-7" style={{ width: '90vw' }}> {/* Set a fixed width */}
        {tabs.map(tab => (
          <div
            key={tab.id}
            className={`${activeTab !== tab.id && 'hidden'}`}
          >
            {tab.content}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Tab;
